/**
 * GameMenu component - start screen
 */

interface GameMenuProps {
  highScore: number;
  onStart: () => void;
}

export function GameMenu({ highScore, onStart }: GameMenuProps) {
  return (
    <div className="game-menu-overlay">
      <div className="game-menu">
        <h1>Precision Clicker</h1>
        <p>
          Click the center of each shape as accurately as possible.
          <br />
          Three strikes and you're out!
        </p>

        {highScore > 0 && (
          <div className="high-score">
            <span>🏆</span>
            <span>High Score: {highScore}</span>
          </div>
        )}

        <button onClick={onStart}>
          ▶️ Start Game
        </button>

        <div style={{ marginTop: '2rem', color: '#9ca3af', fontSize: '0.875rem' }}>
          <p>Perfect center = 100 points</p>
          <p>Distance penalty increases with level</p>
          <p>Timer gets faster each level</p>
        </div>
      </div>
    </div>
  );
}
